exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "#register-store-page{background:#373c40;height:100%}#register-store-page h2{color:#fff;padding:20px;font-size:2.5em}#register-store-page .logo{height:200px}", "", {"version":3,"sources":["/var/www/localhost/public_html/app/vues/src/pages/register-store.vue"],"names":[],"mappings":"AACA,qBACE,mBAAoB,AACpB,WAAa,CACd,AACD,wBACI,WAAa,AACb,aAAc,AACd,eAAiB,CACpB,AACD,2BACI,YAAc,CACjB","file":"register-store.vue","sourcesContent":["\n#register-store-page {\n  background: #373c40;\n  height: 100%;\n}\n#register-store-page h2 {\n    color: white;\n    padding: 20px;\n    font-size: 2.5em;\n}\n#register-store-page .logo {\n    height: 200px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-24fd7625","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"indentedSyntax":true,"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/register-store.vue
// module id = 815
// module chunks = 8